var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNeedHelpIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "question-mark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M26.1316 8.96015C23.3437 8.30356 20.4086 8.96027 18.1662 10.7424C15.9438 12.5044 14.6512 15.1875 14.6585 18.0236C14.6585 19.2269 15.6339 20.2024 16.8372 20.2024C18.0405 20.2024 19.0159 19.2269 19.0159 18.0236C19.0098 15.6372 20.7059 13.5855 23.0509 13.1426C25.3959 12.6997 27.7234 13.9915 28.5881 16.2158C29.4528 18.4401 28.6089 20.9648 26.5805 22.222C23.6562 23.9649 21.8426 27.0974 21.7873 30.5012C21.7873 31.7045 22.7627 32.6799 23.966 32.6799C25.1693 32.6799 26.1447 31.7045 26.1447 30.5012C26.2099 28.6037 27.2494 26.8741 28.8943 25.9259C32.0825 23.9398 33.7652 20.2326 33.1614 16.5252C32.5575 12.8178 29.7853 9.83622 26.1316 8.96451V8.96015Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.966C0 10.7299 10.7299 0 23.966 0C37.1955 0.0156073 47.9163 10.7364 47.9319 23.966C47.9319 37.202 37.202 47.9319 23.966 47.9319C10.7299 47.9319 0 37.202 0 23.966ZM4.35745 23.966C4.35745 34.7954 13.1365 43.5745 23.966 43.5745C34.7905 43.5625 43.5625 34.7905 43.5745 23.966C43.5745 13.1365 34.7954 4.35745 23.966 4.35745C13.1365 4.35745 4.35745 13.1365 4.35745 23.966Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 23.9661,
    cy: 37.0381,
    r: 2.17872,
    fill: "#4A4A4A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNeedHelpIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/needHelpIcon.fa7f5a7e127792cc79b4b7493d3aea8a.svg";